export const types = [
  'primary',
  'secondary',
  'outlined',
  'grayBorder',
  'invertedPrimary',
  'clear',
  'grayed'
];
export const sizeClasses = ['xlarge', 'large', 'medium', 'small', 'xsmall'];
export const textTransform = 'uppercase';
export const fontWeight = 700;
export const borderWidth = '1px';
export const borderRadius = '4px';

export const backgroundColors = {
  primary: '#18181B',
  secondary: '#D2551F',
  outlined: 'unset',
  grayBorder: 'unset',
  invertedPrimary: '#FFFFFF',
  clear: 'unset',
  grayed: '#A6A6A6'
};

export const fontColors = {
  primary: '#FFFFFF',
  secondary: '#FFFFFF',
  outlined: '#18181B',
  grayBorder: '#18181B',
  invertedPrimary: '#18181B',
  clear: '#18181B',
  grayed: '#FFFFFF'
};

export const hoverBackgroundColors = {
  primary: '#3F3F46',
  secondary: '#A84419',
  outlined: '#D4D4D8',
  grayBorder: 'none',
  invertedPrimary: '#FFFFFF',
  clear: 'none',
};

export const focusBackgroundColors = {
  primary: '#52525B',
  secondary: '#7E3313',
  outlined: 'none',
  grayBorder: 'none',
  invertedPrimary: '#FFFFFF',
  clear: 'none',
};

export const borderColors = {
  primary: '#18181B',
  secondary: '#D2551F',
  outlined: '#18181B',
  grayBorder: '#d4d4d8',
  invertedPrimary: '#FFFFFF',
  clear: 'rgba(0,0,0,0)',
  grayed: '#A6A6A6',
};

export const hoverBorderColors = {
  primary: '#3F3F46',
  secondary: '#A84419',
  outlined: '#E4E4E7',
  grayBorder: '#d4d4d8',
  invertedPrimary: '#FFFFFF',
  clear: 'none',
};

export const focusBorderColors = {
  primary: '#52525B',
  secondary: '#7E3313',
  outlined: '#18181B',
  grayBorder: '#d4d4d8',
  invertedPrimary: '#FFFFFF',
  clear: 'none',
};

export const paddings = {
  xlarge: '1.6rem',
  large: '1.2rem',
  medium: '0.8rem 1rem',
  small: '0.8rem',
  xsmall: '0.4rem 0.8rem',
};

export const fontSizes = {
  xlarge: '1.4rem',
  large: '1.4rem',
  medium: '1.2rem',
  small: '1.2rem',
  xsmall: '1rem',
};

export const lineHeights = {
  xlarge: '2.4rem',
  large: '2.4rem',
  medium: '2.4rem',
  small: '1.6rem',
  xsmall: '1.6rem',
};
